import {
  Lit3formBlock,
  html,
  unsafeHTML,
  ifDefined,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  handleAdobeNavEvent,
  adobeCleanString,
} from '../../../helpers/adobe-analytics';

import { vimeoIdFrom } from '@Helpers/vimeo-video';

export class Rocky extends Lit3formBlock {
  static get characterName() {
    return 'rocky';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid rocky-layout">
          ${this.videoId
            ? html`
                <div class="video media">
                  <div class="vimeo-wrapper">
                    <vimeo-video
                      videoid="${this.videoId}"
                      fitaspect
                    ></vimeo-video>
                  </div>
                </div>
              `
            : html`
                <div class="image media">
                  <a
                    href=${ifDefined(
                      this.hasCta ? this.content.cta.url : undefined
                    )}
                    @click="${event => this.handleImageClick(event)}"
                  >
                    <img src="${this.imageUrl}" />
                  </a>
                </div>
              `}
          ${this.showImageDescription
            ? html`
                <p class="image-description description">
                  ${unsafeHTML(this.withLineBreaks(this.imageDescription))}
                </p>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  handleImageClick(event) {
    if (!this.hasCta) return;
    handleAdobeNavEvent({
      navString: `NAV|Image Driver|${adobeCleanString(this.content.cta.text)}`,
      destinationUrl: this.content.cta.url,
      event,
    });
  }

  get videoId() {
    return vimeoIdFrom(this.content.video_url);
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, 1500, null)
      : '';
  }

  get showImageDescription() {
    return this.content.show_image_description && this.hasImageDescription;
  }

  get hasImageDescription() {
    return this.content?.image && this.content?.image?.description;
  }

  get imageDescription() {
    return this.content?.image?.description;
  }
}
Rocky.defineElement();
